// extracted by mini-css-extract-plugin
module.exports = {"campaignReportTableBody":"CampaignReportTableBody_campaignReportTableBody__3L8V6"};